export enum UserRoles {
  ADMIN = 'ADMIN',
  GROUP_ADMIN = 'GROUP_ADMIN',
  USER = 'USER'
}
